import type { JsonWrapperName } from "../types/content";
import type { FiltersStateSettings } from "../types/models";

const JSON_WRAPPER_NAMES_WITH_DISABLED_ACTIONS: ReadonlySet<JsonWrapperName> = new Set([
    "FiltersWereRemoved",
    "SignalsFiltersWereRemoved",
]);

const JSON_WRAPPER_NAMES_WITH_SAVE_FILTERS_ACTIONS: ReadonlySet<JsonWrapperName> = new Set([
    "FiltersWereAdded",
    "FiltersWereModified",
    "FiltersWereRemoved",
    "ExistingFilterSet",
]);

export const buildFiltersStateSettings = (jsonWrapperName: JsonWrapperName): FiltersStateSettings => {
    return {
        isFilterActionEnabled: !JSON_WRAPPER_NAMES_WITH_DISABLED_ACTIONS.has(jsonWrapperName),
        isSaveFiltersEnabled: JSON_WRAPPER_NAMES_WITH_SAVE_FILTERS_ACTIONS.has(jsonWrapperName),
        isSignalDraftActionEnabled: jsonWrapperName === "CraftedSignal",
    };
};
